import { getPlayerPositionColor, getPlayerPositionShort } from '@/helpers/players-helper';
import { Box } from '@mui/material';

const PositionBox = ({ positionId, onClick, styles, fontSize = 10, width = 16, height = 16, ...props }) => {
    const handleOnClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const position = getPlayerPositionShort(positionId);

    return (
        <Box
            color={'#fff'}
            borderRadius={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={`position-color-${getPlayerPositionColor(positionId)} `}
            sx={{ ...styles, fontSize: fontSize, width: width, height: height }}
            onClick={handleOnClick}
            {...props}
        >
            {position}
        </Box>
    );
};

export default PositionBox;
